export default __webpack_public_path__ + "static/media/hello.4a9307f4.svg";